import { render, staticRenderFns } from "./pay-fuwu.vue?vue&type=template&id=11f589c0&scoped=true&"
import script from "./pay-fuwu.vue?vue&type=script&lang=js&"
export * from "./pay-fuwu.vue?vue&type=script&lang=js&"
import style0 from "./pay-fuwu.vue?vue&type=style&index=0&id=11f589c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f589c0",
  null
  
)

export default component.exports